// these names need to match the instance field of WhiteLabels table in the
// database.  We use this unique instance keys for white labels in many places.
import {
  WhiteLabelType,
  WhiteLabelConfigType,
  WhiteLabelTeamType,
} from '../../types/WhiteLabelType';
import wlCache from './cache.json';
import whiteLabelsJSON from './whitelabels.json';

const WHITELABELS = [
  'colliersconnect',
  'dream',
  'exchange365',
  'lane',
  'mimec',
  'mybrookfield',
  'neighborhoods',
  'canderelplus',
  'studio',
  'oxford',
  'triovest',
  'shopify',
  'longfellow',
  'kingsett',
  'hines',
  'hines2',
  'lsh1',
  'pembroke',
  'lwl1', // internal testing whitelabel for staging wl1.s.app.joinlane.com
  'lwl2', // internal testing whitelabel for staging wl2.s.app.joinlane.com
  'regression',
  'pallas',
  'vicland',
  'rfrholdings',
  '118mount',
  'paramountgroup',
  'hostcore',
  'kilroy',
  'accelerate',
  'charterhall',
  'civis',
  '108sgt',
  'cooperscross',
  'harvard',
  'nashvilleyards',
  'fivemerchantsquare',
  'peterboroughcourt',
  'lasierramadrid',
  'evanstonlabs',
  'northaberdeen400',
  'corebridge',
  'brookfieldhq',
  'theribbon',
  'thepictonapp',
  'sconnectapp',
  'plqworkplace',
  'capitolbuilding',
  '125west57thstreet',
  'capellatower',
  '1100peachtree',
  'thecamelliasbydlflimited',
  'westgate',
  'firststreet',
  'onesnowhill',
  'brandywine',
  'intellionplusbytatarealty',
  'boiocenter',
  'monterosa91',
  'taikooplace',
  'pacificplaceoffices',
  'northlasalle300',
  'portlandcommons',
  'centralsquare',
  'vistasorrentolabs',
  '321x',
  'nugacastellana',
  'manulifeplace',
  'finsburycircushouse',
  'forum',
  'stmichaels',
  'uniontrustbuilding',
  'lifeatworkpnc',
  '1georgesquare',
  'rhodesquarter',
  'onelincoln',
  '25yorkstreet',
  '320baystreet',
  '45pirie',
  'halobristol',
  'myogc',
  '150riverside',
  'southbankcentral',
  '440bedford',
  'terminalwarehouse',
  'oneyorkstreet',
  'zgcapital',
  'fifth295',
  'vtsworkplace',
  'thepark',
  'qvperth120',
  'pacifichighway20177',
  'ddmworkspace',
  'polycentre20',
  'fabricarino',
  '1105westpeachtree',
  'bcnfira',
  'hiitbcn',
  'tecom',
  '3columbuscircle',
  'denison201',
  'cristalia',
  '1201newyork',
  '1801penn',
  'theheights',
  'carltonhouse',
  'spectrum',
  'onecitypark',
  'districtwharfoffices',
  '425parkavenue',
  'bridgewatercrossing',
  'nmichigan333',
  'galleriaatl',
  'whitefriars',
  'parkave200',
  'hudsonresearchcenter',
  'onebeacon',
  '200wmadison',
  'northwacker110',
  'centuryparkapp',
  'tenantx',
  '40leadenhall',
  '41lothbury',
  'kudosworkplace',
  'thezoapp',
  '3dworkplace',
  'hosty',
  'waverleygate',
  'fifthnyc717',
  'metronational',
  'epic2024',
  'greenwich101',
  'gate8',
  'spectrumcenter',
  'carnegiecenter',
  'thehub',
  'apexlegacy',
  'commonground',
  'onetwopru',
  'connectbycrown',
  'cqcconnect',
  'victoriaparade200',
  'bethesda2',
  'wisconsin5425',
  'wisconsin2',
  'esrt',
  'cbreim',
  'cannonstreet',
  'finsburysquare',
  'ekistics',
  'westendlabs',
  'perimeter',
  'dundaskiplingcentre',
  'northamericancentre',
  'manulifecorporatepark',
  'universitycentre',
  'universityavenue100',
  'mon1250',
  'arepx',
  'nsioffices',
  'sagerealty',
  'universityave100',
  'colabds',
] as const;

const [
  WHITELABEL_COLLIERSCONNECT,
  WHITELABEL_DREAM,
  WHITELABEL_EXCHANGE365,
  WHITELABEL_LANE,
  WHITELABEL_MIMEC,
  WHITELABEL_MYBROOKFIELD,
  WHITELABEL_NEIGHBORHOOS,
  WHITELABEL_CANDEREL_PLUS,
  WHITELABEL_STUDIO,
  WHITELABEL_OXFORD,
  WHITELABEL_TRIOVEST,
  WHITELABEL_SHOPIFY,
  WHITELABEL_LONGFELLOW,
  WHITELABEL_KINGSETT,
  WHITELABEL_HINES,
  WHITELABEL_HINES2,
  WHITELABEL_LSH,
  WHITELABEL_PEMBROKE,
  WHITELABEL_WL1,
  WHITELABEL_WL2,
  WHITELABEL_REGRESSION,
  WHITELABEL_PALLAS,
  WHITELABEL_VICLAND,
  WHITELABEL_RFR,
  WHITELABEL_118MOUNT,
  WHITELABEL_PARAMOUNTGROUP,
  WHITELABEL_HOSTCORE,
  WHITELABEL_KILROY,
  WHITELABEL_ACCELERATE,
  WHITELABEL_CHARTERHALL,
  WHITELABEL_CIVIS,
  WHITELABEL_108SGT,
  WHITELABEL_COOPERSCROSS,
  WHITELABEL_HARVARD,
  WHITELABEL_NASHVILLEYARDS,
  WHITELABEL_FIVEMERCHANTSQUARE,
  WHITELABEL_PETERBOROUGHCOURT,
  WHITELABEL_LASIERRAMADRID,
  WHITELABEL_EVANSTONLABS,
  WHITELABEL_NORTHABERDEEN400,
  WHITELABEL_COREBRIDGE,
  WHITELABEL_BROOKFIELDHQ,
  WHITELABEL_THERIBBON,
  WHITELABEL_THEPICTONAPP,
  WHITELABEL_SCONNECTAPP,
  WHITELABEL_PLQWORKPLACE,
  WHITELABEL_CAPITOLBUILDING,
  WHITELABEL_125WEST57THSTREET,
  WHITELABEL_CAPELLATOWER,
  WHITELABEL_1100PEACHTREE,
  WHITELABEL_THECAMELLIASBYDLFLIMITED,
  WHITELABEL_WESTGATE,
  WHITELABEL_FIRSTSTREET,
  WHITELABEL_ONESNOWHILL,
  WHITELABEL_BRANDYWINE,
  WHITELABEL_INTELLIONPLUSBYTATAREALTY,
  WHITELABEL_BOIOCENTER,
  WHITELABEL_MONTEROSA91,
  WHITELABEL_TAIKOOPLACE,
  WHITELABEL_PACIFICPLACEOFFICES,
  WHITELABEL_NORTHLASALLE300,
  WHITELABEL_PORTLANDCOMMONS,
  WHITELABEL_CENTRALSQUARE,
  WHITELABEL_VISTASORRENTOLABS,
  WHITELABEL_321X,
  WHITELABEL_NUGACASTELLANA,
  WHITELABEL_MANULIFEPLACE,
  WHITELABEL_FINSBURYCIRCUSHOUSE,
  WHITELABEL_FORUM,
  WHITELABEL_STMICHAELS,
  WHITELABEL_UNIONTRUSTBUILDING,
  WHITELABEL_LIFEATWORKPNC,
  WHITELABEL_1GEORGESQUARE,
  WHITELABEL_RHODESQUARTER,
  WHITELABEL_ONELINCOLN,
  WHITELABEL_25YORKSTREET,
  WHITELABEL_320BAYSTREET,
  WHITELABEL_45PIRIE,
  WHITELABEL_HALOBRISTOL,
  WHITELABEL_MYOGC,
  WHITELABEL_150RIVERSIDE,
  WHITELABEL_SOUTHBANKCENTRAL,
  WHITELABEL_440BEDFORD,
  WHITELABEL_TERMINALWAREHOUSE,
  WHITELABEL_ONEYORKSTREET,
  WHITELABEL_ZGCAPITAL,
  WHITELABEL_FIFTH295,
  WHITELABEL_VTSWORKPLACE,
  WHITELABEL_THEPARK,
  WHITELABEL_QVPERTH120,
  WHITELABEL_PACIFICHIGHWAY20177,
  WHITELABEL_DDMWORKSPACE,
  WHITELABEL_POLYCENTRE20,
  WHITELABEL_FABRICARINO,
  WHITELABEL_1105WESTPEACHTREE,
  WHITELABEL_BCNFIRA,
  WHITELABEL_HIITBCN,
  WHITELABEL_TECOM,
  WHITELABEL_COLUMBUSCIRCLE3,
  WHITELABEL_DENISON201,
  WHITELABEL_CRISTALIA,
  WHITELABEL_1201NEWYORK,
  WHITELABEL_1801PENN,
  WHITELABEL_THEHEIGHTS,
  WHITELABEL_CARLTONHOUSE,
  WHITELABEL_SPECTRUM,
  WHITELABEL_ONECITYPARK,
  WHITELABEL_DISTRICTWHARFOFFICES,
  WHITELABEL_425PARKAVENUE,
  WHITELABEL_BRIDGEWATERCROSSING,
  WHITELABEL_NMICHIGAN333,
  WHITELABEL_GALLERIAATL,
  WHITELABEL_WHITEFRIARS,
  WHITELABEL_PARKAVE200,
  WHITELABEL_HUDSONRESEARCHCENTER,
  WHITELABEL_ONEBEACON,
  WHITELABEL_200WMADISON,
  WHITELABEL_NORTHWACKER110,
  WHITELABEL_CENTURYPARKAPP,
  WHITELABEL_TENANTX,
  WHITELABEL_40LEADENHALL,
  WHITELABEL_41LOTHBURY,
  WHITELABEL_KUDOSWORKPLACE,
  WHITELABEL_THEZOAPP,
  WHITELABEL_3DWORKPLACE,
  WHITELABEL_HOSTY,
  WHITELABEL_WAVERLEYGATE,
  WHITELABEL_FIFTHNYC717,
  WHITELABEL_METRONATIONAL,
  WHITELABEL_EPIC2024,
  WHITELABEL_GREENWICH101,
  WHITELABEL_GATE8,
  WHITELABEL_SPECTRUMCENTER,
  WHITELABEL_CARNEGIECENTER,
  WHITELABEL_THEHUB,
  WHITELABEL_APEXLEGACY,
  WHITELABEL_COMMONGROUND,
  WHITELABEL_ONETWOPRU,
  WHITELABEL_CONNECTBYCROWN,
  WHITELABEL_CQCCONNECT,
  WHITELABEL_VICTORIAPARADE200,
  WHITELABEL_BETHESDA2,
  WHITELABEL_WISCONSIN5425,
  WHITELABEL_WISCONSIN2,
  WHITELABEL_ESRT,
  WHITELABEL_CBREIM,
  WHITELABEL_CANNONSTREET,
  WHITELABEL_FINSBURYSQUARE,
  WHITELABEL_EKISTICS,
  WHITELABEL_WESTENDLABS,
  WHITELABEL_PERIMETER,
  WHITELABEL_DUNDASKIPLINGCENTRE,
  WHITELABEL_NORTHAMERICANCENTRE,
  WHITELABEL_MANULIFECORPORATEPARK,
  WHITELABEL_UNIVERSITYCENTRE,
  WHITELABEL_UNIVERSITYAVENUE100,
  WHITELABEL_MON1250,
  WHITELABEL_AREPX,
  WHITELABEL_NSIOFFICES,
  WHITELABEL_SAGEREALTY,
  WHITELABEL_UNIVERSITYAVE100,
  WHITELABEL_COLABDS,
] = WHITELABELS;

function getWhitelabelByBundleId(bundleId: string) {
  switch (bundleId) {
    case 'com.lane.dream':
      return WHITELABEL_DREAM;
    case 'com.lane.mybrookfield':
      return WHITELABEL_MYBROOKFIELD;
    case 'com.lane.neighborhoods':
      return WHITELABEL_NEIGHBORHOOS;
    case 'com.lane.colliersconnect':
      return WHITELABEL_COLLIERSCONNECT;
    case 'com.lane.mimec':
      return WHITELABEL_MIMEC;
    case 'com.lane.exchange365':
      return WHITELABEL_EXCHANGE365;
    case 'com.lane.canderelplus':
      return WHITELABEL_CANDEREL_PLUS;
    case 'com.lane.oxford':
      return WHITELABEL_OXFORD;
    case 'com.lane.triovest':
      return WHITELABEL_TRIOVEST;
    case 'com.lane.shopify':
      return WHITELABEL_SHOPIFY;
    case 'com.lane.longfellow':
      return WHITELABEL_LONGFELLOW;
    case 'com.lane.kingsett':
      return WHITELABEL_KINGSETT;
    case 'com.lane.hines':
      return WHITELABEL_HINES;
    case 'com.lane.hines2':
      return WHITELABEL_HINES2;
    case 'com.lane.lsh':
      return WHITELABEL_LSH;
    case 'com.lane.pembroke':
      return WHITELABEL_PEMBROKE;
    case 'com.lane.wl1':
      return WHITELABEL_WL1;
    case 'com.lane.wl2':
      return WHITELABEL_WL2;
    case 'com.vts.activate.sampleapp':
      return WHITELABEL_REGRESSION;
    case 'com.lane.pallas':
      return WHITELABEL_PALLAS;
    case 'com.lane.118mount':
    case 'com.lane.mount':
      return WHITELABEL_118MOUNT;
    case 'com.lane.vicland':
      return WHITELABEL_VICLAND;
    case 'com.risesoftware.rfr':
      return WHITELABEL_RFR;
    case 'com.risesoftware.paramountgroup':
      return WHITELABEL_PARAMOUNTGROUP;
    case 'com.vts.activate.cbre.hostcore':
      return WHITELABEL_HOSTCORE;
    case 'com.risesoftware.kilroy':
      return WHITELABEL_KILROY;
    case 'com.vts.activate.accelerate':
      return WHITELABEL_ACCELERATE;
    case 'com.vts.activate.charterhall':
      return WHITELABEL_CHARTERHALL;
    case 'com.vts.activate.sgt108':
      return WHITELABEL_108SGT;
    case 'com.risesoftware.coopercross':
      return WHITELABEL_COOPERSCROSS;
    case 'com.vts.activate.harvard':
      return WHITELABEL_HARVARD;
    case 'com.nashville.yards':
      return WHITELABEL_NASHVILLEYARDS;
    case 'com.nashvilleyards.nashville-yards':
      return WHITELABEL_NASHVILLEYARDS;
    case 'com.risesoftware.fivemerchantsquare':
      return WHITELABEL_FIVEMERCHANTSQUARE;
    case 'com.vts.activate.peterboroughcourt':
      return WHITELABEL_PETERBOROUGHCOURT;
    case 'com.madrid.lasierra':
      return WHITELABEL_LASIERRAMADRID;
    case 'com.lasierramadrid.app':
      return WHITELABEL_LASIERRAMADRID;
    case 'com.vts.activate.evanstonlabs':
      return WHITELABEL_EVANSTONLABS;
    case 'com.vts.activate.northaberdeen400':
      return WHITELABEL_NORTHABERDEEN400;
    case 'com.vts.activate.corebridge':
      return WHITELABEL_COREBRIDGE;
    case 'com.vts.activate.brookfieldhq':
      return WHITELABEL_BROOKFIELDHQ;
    case 'com.vts.activate.theribbon':
      return WHITELABEL_THERIBBON;
    case 'uk.co.picton':
      return WHITELABEL_THEPICTONAPP;
    case 'com.schroders.sconnect':
      return WHITELABEL_SCONNECTAPP;
    case 'com.vts.activate.plqworkplace':
      return WHITELABEL_PLQWORKPLACE;
    case 'com.vts.activate.capitolbuilding':
      return WHITELABEL_CAPITOLBUILDING;
    case 'com.vts.activate.w57th125':
      return WHITELABEL_125WEST57THSTREET;
    case 'com.vts.activate.capellatower':
      return WHITELABEL_CAPELLATOWER;
    case 'com.vts.activate.peachtree1100':
      return WHITELABEL_1100PEACHTREE;
    case 'in.dlf.camellias':
      return WHITELABEL_THECAMELLIASBYDLFLIMITED;
    case 'com.vts.activate.westgate':
      return WHITELABEL_WESTGATE;
    case 'com.ask.firststreet':
      return WHITELABEL_FIRSTSTREET;
    case 'uk.co.askrealestate.firststreet':
      return WHITELABEL_FIRSTSTREET;
    case 'com.vts.activate.onesnowhill':
      return WHITELABEL_ONESNOWHILL;
    case 'com.vts.activate.brandywineaccess':
      return WHITELABEL_BRANDYWINE;
    case 'in.tatarealty.intellion':
    case 'in.tatareality.intellion':
      return WHITELABEL_INTELLIONPLUSBYTATAREALTY;
    case 'com.vts.activate.bodiocenter':
      return WHITELABEL_BOIOCENTER;
    case 'com.vts.activate.monterosa91':
      return WHITELABEL_MONTEROSA91;
    case 'com.taikooplace.tpapp':
      return WHITELABEL_TAIKOOPLACE;
    case 'com.taikooplace.host':
      return WHITELABEL_TAIKOOPLACE;
    case 'com.swire.ppoffices':
      return WHITELABEL_PACIFICPLACEOFFICES;
    case 'hk.com.pacificplace.app':
      return WHITELABEL_PACIFICPLACEOFFICES;
    case 'com.vts.activate.northlasalle300':
      return WHITELABEL_NORTHLASALLE300;
    case 'com.vts.activate.portlandcommons':
      return WHITELABEL_PORTLANDCOMMONS;
    case 'com.vts.activate.centralsquare':
      return WHITELABEL_CENTRALSQUARE;
    case 'com.vts.activate.vistasorrentolabs':
      return WHITELABEL_VISTASORRENTOLABS;
    case 'com.vts.activate.x321':
      return WHITELABEL_321X;
    case 'com.castellana200.castellana200':
      return WHITELABEL_NUGACASTELLANA;
    case 'com.cbre.castellana200':
      return WHITELABEL_NUGACASTELLANA;
    case 'com.manulifeplace-hk.app':
    case 'com.paghk.manulifeplace':
      return WHITELABEL_MANULIFEPLACE;
    case 'com.vts.activate.sampleapp4':
    case 'com.risesoftware.esrt':
      return WHITELABEL_ESRT;
    case 'com.vts.activate.fch':
      return WHITELABEL_FINSBURYCIRCUSHOUSE;
    case 'com.vts.activate.forum':
      return WHITELABEL_FORUM;
    case 'com.vts.activate.stmichaels':
      return WHITELABEL_STMICHAELS;
    case 'com.vts.activate.uniontrust':
      return WHITELABEL_UNIONTRUSTBUILDING;
    case 'com.vts.activate.lifeatwork':
      return WHITELABEL_LIFEATWORKPNC;
    case 'com.vts.activate.george1':
      return WHITELABEL_1GEORGESQUARE;
    case 'com.vts.activate.rhodesquarter':
      return WHITELABEL_RHODESQUARTER;
    case 'com.vts.activate.onelincoln':
      return WHITELABEL_ONELINCOLN;
    case 'com.risesoftware.yorkstreet':
      return WHITELABEL_25YORKSTREET;
    case 'com.risesoftware.baystreet':
      return WHITELABEL_320BAYSTREET;
    case 'com.vts.activate.pirie45':
      return WHITELABEL_45PIRIE;
    case 'com.vts.activate.halobristol':
      return WHITELABEL_HALOBRISTOL;
    case 'com.vts.activate.myogc':
      return WHITELABEL_MYOGC;
    case 'com.vts.activate.riverside150':
      return WHITELABEL_150RIVERSIDE;
    case 'com.risesoftware.southbank':
      return WHITELABEL_SOUTHBANKCENTRAL;
    case 'com.vts.activate.bedford440':
      return WHITELABEL_440BEDFORD;
    case 'com.vts.activate.terminal':
      return WHITELABEL_TERMINALWAREHOUSE;
    case 'com.risesoftware.oneyork':
      return WHITELABEL_ONEYORKSTREET;
    case 'com.vts.activate.zgcapital':
      return WHITELABEL_ZGCAPITAL;
    case 'com.vts.activate.fifth295':
      return WHITELABEL_FIFTH295;
    case 'com.vts.activate.vtsworkplace':
      return WHITELABEL_VTSWORKPLACE;
    case 'com.cbre.host.connell.park':
      return WHITELABEL_THEPARK;
    case 'com.vts.activate.qvperth120':
      return WHITELABEL_QVPERTH120;
    case 'com.vts.activate.pacifichighway20177':
      return WHITELABEL_PACIFICHIGHWAY20177;
    case 'com.vts.activate.ddm':
      return WHITELABEL_DDMWORKSPACE;
    case 'com.vts.activate.polycentre20':
      return WHITELABEL_POLYCENTRE20;
    case 'com.vts.activate.fabricarino':
      return WHITELABEL_FABRICARINO;
    case 'com.peachtree.west':
    case 'com.1105westpeachtree.app':
      return WHITELABEL_1105WESTPEACHTREE;
    case 'com.aberdeenstandard.bcnfira':
    case 'com.cbre.bcnfira':
      return WHITELABEL_BCNFIRA;
    case 'com.vts.activate.hiitbcn':
      return WHITELABEL_HIITBCN;
    case 'com.vts.activate.tecom':
      return WHITELABEL_TECOM;
    case 'com.vts.activate.columbuscircle3':
      return WHITELABEL_COLUMBUSCIRCLE3;
    case 'com.vts.activate.denison201':
      return WHITELABEL_DENISON201;
    case 'com.vts.activate.cristalia':
      return WHITELABEL_CRISTALIA;
    case 'com.risesoftware.newyork1201':
      return WHITELABEL_1201NEWYORK;
    case 'com.risesoftware.penn1801':
      return WHITELABEL_1801PENN;
    case 'com.vts.activate.theheights':
      return WHITELABEL_THEHEIGHTS;
    case 'com.vts.activate.cht20':
      return WHITELABEL_CARLTONHOUSE;
    case 'com.vts.activate.aliados':
      return WHITELABEL_SPECTRUM;
    case 'com.vts.activate.bradford':
      return WHITELABEL_ONECITYPARK;
    case 'com.vts.activate.wharfdc':
      return WHITELABEL_DISTRICTWHARFOFFICES;
    case 'com.vts.activate.park425':
    case 'com.vts.activate.park425a':
      return WHITELABEL_425PARKAVENUE;
    case 'com.vts.activate.bridgewatercrossing':
      return WHITELABEL_BRIDGEWATERCROSSING;
    case 'com.risesoftware.michigan333':
      return WHITELABEL_NMICHIGAN333;
    case 'com.risesoftware.galleriaatl':
      return WHITELABEL_GALLERIAATL;
    case 'com.risesoftware.whitefriarsbristol':
      return WHITELABEL_WHITEFRIARS;
    case 'com.vts.activate.parkave200':
    case 'com.vts.activate.parkave200a':
      return WHITELABEL_PARKAVE200;
    case 'hudson.research.center':
    case 'com.tacon.hrcnyc':
      return WHITELABEL_HUDSONRESEARCHCENTER;
    case 'com.vts.activate.onebeacon':
      return WHITELABEL_ONEBEACON;
    case 'com.bentallgreenoak.madison':
      return WHITELABEL_200WMADISON;
    case 'com.vts.activate.northwacker110':
      return WHITELABEL_NORTHWACKER110;
    case 'com.vts.activate.centuryparkapp':
      return WHITELABEL_CENTURYPARKAPP;
    case 'com.vts.activate.tenantx':
      return WHITELABEL_TENANTX;
    case 'com.vts.activate.leadenhall':
      return WHITELABEL_40LEADENHALL;
    case 'com.vts.activate.lothbury':
      return WHITELABEL_41LOTHBURY;
    case 'com.vts.activate.kudosworkplace':
    case 'com.kudosworkplace.kudos':
    case 'com.workplace.kudos':
      return WHITELABEL_KUDOSWORKPLACE;
    case 'com.findyourzo.zomobile':
    case 'com.RCPILandmarkProperties.findyourzo':
      return WHITELABEL_THEZOAPP;
    case 'com.development.workplace':
      return WHITELABEL_3DWORKPLACE;
    case 'com.cbre.hosty':
      return WHITELABEL_HOSTY;
    case 'com.vts.activate.waverlaygate':
    case 'com.vts.activate.waverley':
      return WHITELABEL_WAVERLEYGATE;
    case 'com.vts.activate.fifthnyc717':
      return WHITELABEL_FIFTHNYC717;
    case 'com.risesoftware.mcitywork':
      return WHITELABEL_METRONATIONAL;
    case 'com.vts.activate.epic2024':
      return WHITELABEL_EPIC2024;
    case 'com.risesoftware.greenwich101':
      return WHITELABEL_GREENWICH101;
    case 'com.vts.activate.gate8':
      return WHITELABEL_GATE8;
    case 'com.vts.activate.spectrum':
      return WHITELABEL_SPECTRUMCENTER;
    case 'com.risesoftware.carnegiecenter':
      return WHITELABEL_CARNEGIECENTER;
    case 'com.risesoftware.thehub':
      return WHITELABEL_THEHUB;
    case 'com.apexlegacy':
    case 'com.apex1.app':
      return WHITELABEL_APEXLEGACY;
    case 'com.vts.activate.commonground':
      return WHITELABEL_COMMONGROUND;
    case 'com.risesoftware.onetwopru':
      return WHITELABEL_ONETWOPRU;
    case 'com.vts.activate.sampleapp6':
    case 'com.risesoftware.connectbycrown':
      return WHITELABEL_CONNECTBYCROWN;
    case 'com.vts.activate.cqcconnect':
    case 'com.vts.activate.cqcconnect2':
      return WHITELABEL_CQCCONNECT;
    case 'com.vts.activate.victoriaparade200':
      return WHITELABEL_VICTORIAPARADE200;
    case 'com.vts.activate.bethesda2':
      return WHITELABEL_BETHESDA2;
    case 'com.vts.activate.wisconsin5425':
      return WHITELABEL_WISCONSIN5425;
    case 'com.vts.activate.wisconsin2':
      return WHITELABEL_WISCONSIN2;
    case 'com.vts.activate.cbreim':
      return WHITELABEL_CBREIM;
    case 'com.risesoftware.cannonstreet':
      return WHITELABEL_CANNONSTREET;
    case 'com.risesoftware.finsburysquare':
      return WHITELABEL_FINSBURYSQUARE;
    case 'com.risesoftware.saintjames':
      return WHITELABEL_EKISTICS;
    case 'com.vts.activate.westendlabs':
      return WHITELABEL_WESTENDLABS;
    case 'com.vts.activate.perimeter':
      return WHITELABEL_PERIMETER;
    case 'com.vts.activate.sampleapp13':
      return WHITELABEL_DUNDASKIPLINGCENTRE;
    case 'com.vts.activate.sampleapp12':
      return WHITELABEL_NORTHAMERICANCENTRE;
    case 'com.vts.activate.sampleapp11':
      return WHITELABEL_MANULIFECORPORATEPARK;
    case 'com.vts.activate.sampleapp10':
      return WHITELABEL_UNIVERSITYCENTRE;
    case 'com.vts.activate.sampleapp9':
      return WHITELABEL_UNIVERSITYAVENUE100;
    case 'com.vts.activate.mon1250':
      return WHITELABEL_MON1250;
    case 'com.vts.activate.sampleapp7':
      return WHITELABEL_AREPX;
    case 'com.risesoftware.sage':
      return WHITELABEL_SAGEREALTY;
    case 'com.vts.activate.nsi':
      return WHITELABEL_NSIOFFICES;
    case 'com.vts.activate.colabds':
    case 'com.vts.activate.colabds2':
      return WHITELABEL_COLABDS;
    case 'com.lane.studio':
    case 'com.yourstudio.app':
    case 'com.yourstudio.yourstudio':
      return WHITELABEL_STUDIO;
    case 'com.lane.civis':
      return WHITELABEL_CIVIS;
    case 'com.lane.lane':
    case 'com.lane.staging':
    case 'com.lane.develop':
    case 'com.lane.uat':
    case 'com.lane.laneuat':
    case 'com.vts.activate.sampleapp3':
    default:
      return WHITELABEL_LANE;
  }
}

const cache: WhiteLabelType[] = wlCache as unknown as WhiteLabelType[];
const whiteLabelsConfig: WhiteLabelConfigType[] =
  whiteLabelsJSON.whitelabels as unknown as WhiteLabelConfigType[];
const whiteLabelsTeam: WhiteLabelTeamType[] =
  whiteLabelsJSON.ios_stores as unknown as WhiteLabelTeamType[];

export {
  cache,
  whiteLabelsConfig,
  whiteLabelsTeam,
  WHITELABELS,
  getWhitelabelByBundleId,
  WHITELABEL_CANDEREL_PLUS,
  WHITELABEL_COLLIERSCONNECT,
  WHITELABEL_DREAM,
  WHITELABEL_EXCHANGE365,
  WHITELABEL_LANE,
  WHITELABEL_MIMEC,
  WHITELABEL_MYBROOKFIELD,
  WHITELABEL_NEIGHBORHOOS,
  WHITELABEL_STUDIO,
  WHITELABEL_OXFORD,
  WHITELABEL_TRIOVEST,
  WHITELABEL_SHOPIFY,
  WHITELABEL_LONGFELLOW,
  WHITELABEL_KINGSETT,
  WHITELABEL_HINES,
  WHITELABEL_HINES2,
  WHITELABEL_LSH,
  WHITELABEL_PEMBROKE,
  WHITELABEL_WL1,
  WHITELABEL_WL2,
  WHITELABEL_REGRESSION,
  WHITELABEL_PALLAS,
  WHITELABEL_VICLAND,
  WHITELABEL_RFR,
  WHITELABEL_118MOUNT,
  WHITELABEL_PARAMOUNTGROUP,
  WHITELABEL_HOSTCORE,
  WHITELABEL_KILROY,
  WHITELABEL_ACCELERATE,
  WHITELABEL_CHARTERHALL,
  WHITELABEL_CIVIS,
  WHITELABEL_108SGT,
  WHITELABEL_COOPERSCROSS,
  WHITELABEL_HARVARD,
  WHITELABEL_NASHVILLEYARDS,
  WHITELABEL_FIVEMERCHANTSQUARE,
  WHITELABEL_PETERBOROUGHCOURT,
  WHITELABEL_LASIERRAMADRID,
  WHITELABEL_EVANSTONLABS,
  WHITELABEL_NORTHABERDEEN400,
  WHITELABEL_COREBRIDGE,
  WHITELABEL_BROOKFIELDHQ,
  WHITELABEL_THERIBBON,
  WHITELABEL_THEPICTONAPP,
  WHITELABEL_SCONNECTAPP,
  WHITELABEL_PLQWORKPLACE,
  WHITELABEL_CAPITOLBUILDING,
  WHITELABEL_125WEST57THSTREET,
  WHITELABEL_CAPELLATOWER,
  WHITELABEL_1100PEACHTREE,
  WHITELABEL_THECAMELLIASBYDLFLIMITED,
  WHITELABEL_WESTGATE,
  WHITELABEL_FIRSTSTREET,
  WHITELABEL_ONESNOWHILL,
  WHITELABEL_BRANDYWINE,
  WHITELABEL_INTELLIONPLUSBYTATAREALTY,
  WHITELABEL_BOIOCENTER,
  WHITELABEL_MONTEROSA91,
  WHITELABEL_TAIKOOPLACE,
  WHITELABEL_PACIFICPLACEOFFICES,
  WHITELABEL_NORTHLASALLE300,
  WHITELABEL_PORTLANDCOMMONS,
  WHITELABEL_CENTRALSQUARE,
  WHITELABEL_VISTASORRENTOLABS,
  WHITELABEL_321X,
  WHITELABEL_NUGACASTELLANA,
  WHITELABEL_MANULIFEPLACE,
  WHITELABEL_FINSBURYCIRCUSHOUSE,
  WHITELABEL_FORUM,
  WHITELABEL_STMICHAELS,
  WHITELABEL_UNIONTRUSTBUILDING,
  WHITELABEL_LIFEATWORKPNC,
  WHITELABEL_1GEORGESQUARE,
  WHITELABEL_RHODESQUARTER,
  WHITELABEL_ONELINCOLN,
  WHITELABEL_25YORKSTREET,
  WHITELABEL_320BAYSTREET,
  WHITELABEL_45PIRIE,
  WHITELABEL_HALOBRISTOL,
  WHITELABEL_MYOGC,
  WHITELABEL_150RIVERSIDE,
  WHITELABEL_SOUTHBANKCENTRAL,
  WHITELABEL_440BEDFORD,
  WHITELABEL_TERMINALWAREHOUSE,
  WHITELABEL_ONEYORKSTREET,
  WHITELABEL_ZGCAPITAL,
  WHITELABEL_FIFTH295,
  WHITELABEL_VTSWORKPLACE,
  WHITELABEL_THEPARK,
  WHITELABEL_QVPERTH120,
  WHITELABEL_PACIFICHIGHWAY20177,
  WHITELABEL_DDMWORKSPACE,
  WHITELABEL_POLYCENTRE20,
  WHITELABEL_FABRICARINO,
  WHITELABEL_1105WESTPEACHTREE,
  WHITELABEL_BCNFIRA,
  WHITELABEL_HIITBCN,
  WHITELABEL_TECOM,
  WHITELABEL_COLUMBUSCIRCLE3,
  WHITELABEL_DENISON201,
  WHITELABEL_CRISTALIA,
  WHITELABEL_1201NEWYORK,
  WHITELABEL_1801PENN,
  WHITELABEL_THEHEIGHTS,
  WHITELABEL_CARLTONHOUSE,
  WHITELABEL_SPECTRUM,
  WHITELABEL_ONECITYPARK,
  WHITELABEL_DISTRICTWHARFOFFICES,
  WHITELABEL_425PARKAVENUE,
  WHITELABEL_BRIDGEWATERCROSSING,
  WHITELABEL_NMICHIGAN333,
  WHITELABEL_GALLERIAATL,
  WHITELABEL_WHITEFRIARS,
  WHITELABEL_PARKAVE200,
  WHITELABEL_HUDSONRESEARCHCENTER,
  WHITELABEL_ONEBEACON,
  WHITELABEL_200WMADISON,
  WHITELABEL_NORTHWACKER110,
  WHITELABEL_CENTURYPARKAPP,
  WHITELABEL_TENANTX,
  WHITELABEL_40LEADENHALL,
  WHITELABEL_41LOTHBURY,
  WHITELABEL_KUDOSWORKPLACE,
  WHITELABEL_THEZOAPP,
  WHITELABEL_3DWORKPLACE,
  WHITELABEL_HOSTY,
  WHITELABEL_WAVERLEYGATE,
  WHITELABEL_FIFTHNYC717,
  WHITELABEL_METRONATIONAL,
  WHITELABEL_EPIC2024,
  WHITELABEL_GREENWICH101,
  WHITELABEL_GATE8,
  WHITELABEL_SPECTRUMCENTER,
  WHITELABEL_CARNEGIECENTER,
  WHITELABEL_THEHUB,
  WHITELABEL_APEXLEGACY,
  WHITELABEL_COMMONGROUND,
  WHITELABEL_ONETWOPRU,
  WHITELABEL_CONNECTBYCROWN,
  WHITELABEL_CQCCONNECT,
  WHITELABEL_VICTORIAPARADE200,
  WHITELABEL_BETHESDA2,
  WHITELABEL_WISCONSIN5425,
  WHITELABEL_WISCONSIN2,
  WHITELABEL_ESRT,
  WHITELABEL_CBREIM,
  WHITELABEL_CANNONSTREET,
  WHITELABEL_FINSBURYSQUARE,
  WHITELABEL_EKISTICS,
  WHITELABEL_WESTENDLABS,
  WHITELABEL_PERIMETER,
  WHITELABEL_DUNDASKIPLINGCENTRE,
  WHITELABEL_NORTHAMERICANCENTRE,
  WHITELABEL_MANULIFECORPORATEPARK,
  WHITELABEL_UNIVERSITYCENTRE,
  WHITELABEL_UNIVERSITYAVENUE100,
  WHITELABEL_MON1250,
  WHITELABEL_AREPX,
  WHITELABEL_NSIOFFICES,
  WHITELABEL_SAGEREALTY,
  WHITELABEL_UNIVERSITYAVE100,
  WHITELABEL_COLABDS,
};
